import type { Point } from "geojson"

/** Safely extract [lng, lat] from a GeoJSON Point geometry. */
export function getCoordinates(
  geometry: Point
): [lng: number, lat: number] | null {
  const [lng, lat] = geometry.coordinates
  if (typeof lng !== "number" || typeof lat !== "number") return null
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null
  return [lng, lat]
}
